import { render, staticRenderFns } from "./priceresult.vue?vue&type=template&id=66bf6c85&scoped=true"
import script from "./priceresult.vue?vue&type=script&lang=js"
export * from "./priceresult.vue?vue&type=script&lang=js"
import style0 from "./priceresult.vue?vue&type=style&index=0&id=66bf6c85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf6c85",
  null
  
)

export default component.exports